// Aplica cupom de desconto no carrinho via Shopify Ajax API.
// Event delegation no body porque o drawer é re-renderizado via $.html() (scripts inline não rodam).
(function ($) {
  if (!$) return;

  function setMsg(root, type, text) {
    var msg = root.querySelector('[data-yv-cart-coupon-msg]');
    if (!msg) return;
    msg.className = 'yv-cart-coupon__msg' + (type ? ' is-' + type : '');
    msg.textContent = text || '';
  }

  function aplicarCupom(root) {
    var input = root.querySelector('#yv-cart-coupon-input');
    var btn = root.querySelector('[data-yv-cart-coupon-btn]');
    if (!input || !btn) return;

    var code = (input.value || '').trim().toUpperCase();
    if (!code) {
      setMsg(root, 'error', 'Digite um cupom.');
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    setMsg(root, '', 'Aplicando cupom...');

    // Shopify Ajax API: POST /cart/update.js com discount param
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (resp) {
        var data = resp.data || {};
        var applied = (data.cart_level_discount_applications || []).filter(function (d) {
          return (d.title || '').toUpperCase() === code;
        });
        if (resp.ok && applied.length > 0) {
          setMsg(root, 'success', 'Cupom aplicado: ' + applied[0].title);
          // Re-render cart drawer com novo total
          if (typeof window.buildCart === 'function') {
            $.getJSON('/cart.js', function (cart) { window.buildCart(cart, true); });
          } else {
            // Fallback: dispara o reload do drawer pelo cart-ajax do tema
            $.getJSON('/cart.js', function (cart) {
              if (typeof window.buildCart === 'function') window.buildCart(cart, true);
            });
          }
        } else if (resp.ok && data.discount_codes && data.discount_codes.length > 0) {
          // Algumas versões do Shopify retornam discount_codes
          var dc = data.discount_codes.find(function (d) { return d.applicable; });
          if (dc) {
            setMsg(root, 'success', 'Cupom aplicado: ' + dc.code);
            $.getJSON('/cart.js', function (cart) {
              if (typeof window.buildCart === 'function') window.buildCart(cart, true);
            });
          } else {
            setMsg(root, 'error', 'Cupom inválido ou não aplicável a este carrinho.');
          }
        } else {
          var msg = (data && data.description) || (data && data.message) || 'Cupom inválido ou não aplicável.';
          setMsg(root, 'error', msg);
        }
      })
      .catch(function () {
        setMsg(root, 'error', 'Erro ao aplicar cupom. Tente novamente.');
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function removerCupom(code, root, btn) {
    if (btn) btn.disabled = true;
    if (root) setMsg(root, '', 'Removendo cupom...');

    // Shopify Ajax API: discount vazio limpa o(s) código(s) aplicado(s) no carrinho
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (resp) {
        var data = resp.data || {};
        var stillApplied = (data.cart_level_discount_applications || []).some(function (d) {
          return (d.title || '').toUpperCase() === (code || '').toUpperCase();
        });
        if (resp.ok && !stillApplied) {
          if (root) setMsg(root, 'success', 'Cupom removido.');
        } else {
          if (root) setMsg(root, 'error', 'Não foi possível remover o cupom.');
        }
        // Re-renderiza o drawer (o chip some sozinho via Liquid quando o código sai)
        $.getJSON('/cart.js', function (cart) {
          if (typeof window.buildCart === 'function') window.buildCart(cart, true);
        });
      })
      .catch(function () {
        if (root) setMsg(root, 'error', 'Erro ao remover cupom. Tente novamente.');
        if (btn) btn.disabled = false;
      });
  }

  $(document).ready(function () {
    // Aplica ao clicar no botão
    $('body').on('click', '[data-yv-cart-coupon-btn]', function () {
      var root = this.closest('[data-yv-cart-coupon]');
      if (root) aplicarCupom(root);
    });
    // Remove o cupom aplicado ao clicar no X do chip
    $('body').on('click', '[data-yv-cart-coupon-remove]', function () {
      var root = this.closest('[data-yv-cart-coupon]');
      removerCupom(this.getAttribute('data-yv-cart-coupon-remove'), root, this);
    });
    // Aplica ao apertar Enter no input
    $('body').on('keydown', '#yv-cart-coupon-input', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var root = this.closest('[data-yv-cart-coupon]');
        if (root) aplicarCupom(root);
      }
    });
  });
})(window.jQuery);
